/**
 * One-tap quick replies for the DM composer, shared by the client and
 * town-square thread views. Tapping a chip sends it immediately.
 *
 * The emoji set is always shown. The phrase set here is the curated fallback;
 * when AI context-aware suggestions are available the thread view swaps them in
 * and falls back to these.
 */

export const QUICK_REPLY_EMOJIS = ['👍', '❤️', '😂', '🔥', '🎉', '🙏'];

export const QUICK_REPLY_PHRASES = [
  'Thanks!',
  'Love this!',
  'Congrats! 🎉',
  'Sounds great!',
  "Can't wait to see it!",
  'Amazing work!',
];

/** How many AI suggestions to request/show. */
export const MAX_AI_QUICK_REPLIES = 3;

/**
 * OPENING LINES for writing to an artist about a specific piece — the note step in the
 * dormant-revival quest, where there is no previous message to reply to.
 *
 * These are the curated fallback, used whenever the AI returns nothing. They are
 * deliberately weaker than what the model produces, because a generic "love your work!"
 * from a stranger is the exact thing that makes this read as spam — which is why the
 * model is asked to name the piece, and why every one of these is editable before it is
 * sent and none of them is ever sent automatically.
 */
export const NOTE_OPENER_PHRASES = [
  'This one stopped me scrolling.',
  'The colours in this are doing something.',
  'Been looking at this for a while.',
  'Hope you are still making these.',
];

/** How many AI openers to request/show. */
export const MAX_AI_NOTE_OPENERS = 3;

/**
 * FALLBACK one-tap praise, used only when generation fails.
 *
 * Deliberately short: the real chips are generated about the piece in front of her,
 * because a fixed pool cannot survive scale — once thousands of members are sending
 * these, the same sentences circulate platform-wide and start reading as a bot, which is
 * the one thing a nudge from a person must never read as (Nick, 2026-09-26).
 *
 * Never references time away. The sender has no way of knowing the artist had been gone —
 * we told them — so implying it is both creepy and a leak of how this works.
 */
export const QUICK_PRAISE_FALLBACK = [
  'This is really good.',
  'Love the colours in this.',
  'This deserves more eyes.',
  'You have a great eye.',
];
